import type { MenuSummaryDto } from "../../../shared/api-types";
import { CHIPS } from "../../components/kit";
import { plural } from "../../lib/format";

/** Menu status chip (prototype `mChip`). */
export function menuChip(m: MenuSummaryDto) {
  if (m.status === "pending") {
    return {
      ...CHIPS.pending,
      label: `Publicat · ${plural(m.pendingChanges ?? 0, "modificare", "modificări")} în ciornă`,
    };
  }
  return CHIPS[m.status];
}

/**
 * The menu the overview and topbar talk about (prototype `mainM`): the first public one; else the newest
 * non-archived menu with products (an import fills a new menu at the end of the list, and an empty "Meniul
 * principal" created earlier must not hide it); else the first non-archived one.
 */
export function mainMenu(menus: MenuSummaryDto[]): MenuSummaryDto | undefined {
  const active = menus.filter((m) => !m.archived);
  return (
    active.find((m) => m.publicVisible) ?? [...active].reverse().find((m) => m.productCount > 0) ?? active[0]
  );
}
